import { PaginationBox } from "components/Pagination/PaginationBox";
import { Wrapper, Content, Container } from "../style";
import SearchCategory from "../../SearchCategory";
import { useState } from "react";
import { POST_WALLET_INFO_BACK } from "constants/pathConstant";
import { Info, List } from "template/ListTemplate.style";
import backColumn from "./backByUserColumn.json";
import BackByUserDetail from "./BackByUserDetail";
import { WALLET_INFO_BACK_XLSX_DOWNLOAD } from "constants/xlsxDownloadConstant";

// 회원검색 (검증 후 회원 정보 바로가기) :: 지갑정보 -> 스케치 백 (http://localhost:3000/manage/user/:code)
const BackByUser = ({ id }) => {
  const [page, setPage] = useState(1);
  const [size, setSize] = useState(10);
  const [resData, setResData] = useState({ list: [], listCount: 0 });

  const data = {
    id,
    currentPage: page,
    pageSize: size,
  };

  return (
    <Wrapper>
      <SearchCategory
        API_ADDRESS={POST_WALLET_INFO_BACK}
        data={data}
        setResData={setResData}
        setPage={setPage}
        setSize={setSize}
        page={page}
        size={size}
        resData={resData}
        XLSX_DOWNLOAD={WALLET_INFO_BACK_XLSX_DOWNLOAD}
      />

      <Container>
        <Content>
          {backColumn.data.map((v, idx) => (
            <List.Row $ratio={v.ratio} key={idx}>
              {v.title}
            </List.Row>
          ))}
        </Content>

        <Info.Wrapper>
          {resData.list?.map((v, idx) => (
            <BackByUserDetail data={v} key={idx} />
          ))}
        </Info.Wrapper>
      </Container>

      {resData.listCount > 0 && (
        <PaginationBox
          totalItemsCount={resData.listCount}
          page={page}
          setPage={setPage}
          size={size}
        />
      )}
    </Wrapper>
  );
};

export default BackByUser;
